import React, { useState } from "react";
import { useTranslation } from "react-i18next";

// TODO: Implementation seems more complicated that it should be, revisit it!
function MultipleChoice({
  question,
  choices,
  qKey,
  onSubmitHandler,
  selectedChoices = {},
  isPillView = false,
}) {
  const [currentChoice, setChoice] = useState(selectedChoices);
  const { t } = useTranslation();
  const getExclusiveOption = () =>
    choices.find((choice) => choice.hasOwnProperty("exclusive"));

  const handleChange = (e, choice) => {
    //console.log(choice);
    const { id, value } = e.target;
    if (choice.hasOwnProperty("exclusive")) {
      setChoice({
        [id]: {
          checked: !isChecked(id),
          value: value,
          id: id,
        },
      });
    } else {
      setChoice((prevState) => {
        const exclusiveOption = getExclusiveOption();
        if (exclusiveOption) {
          delete prevState[getExclusiveOption()["id"]];
        }
        const newState = {
          ...prevState,
          [id]: {
            checked: !isChecked(id),
            value: value,
            id: id,
          },
        };
        return newState;
      });
    }
  };

  const isChecked = (choiceId) => {
    const _choiceState = currentChoice[choiceId];
    if (_choiceState && _choiceState.hasOwnProperty("checked")) {
      return _choiceState["checked"];
    } else {
      return false;
    }
  };

  // TODO: Identify simpler way of check this
  const isResponseEmpty = () => {
    let _isReponseEmpty = true;
    Object.keys(currentChoice).forEach((key) => {
      if (currentChoice[key]["checked"]) {
        _isReponseEmpty = false;
        return;
      }
    });
    return _isReponseEmpty;
  };

  const Choices = choices.map((choice, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="checkbox"
            name={qKey}
            key={choice.id}
            value={choice.value}
            id={choice.id}
            checked={isChecked(choice.id)}
            onChange={(e) => handleChange(e, choice)}
          />
          <span className="dot"></span>
          <span className="txt">{choice.text}</span>
        </label>
      </li>
    );
  });

  return (
    <>
      <h3 className="headtitle">{question}</h3>
      <ul
        className={
          isPillView
            ? "list-unstyled list_switch_checkbox"
            : "list-unstyled list_checkbox_btn"
        }
      >
        {Choices}
      </ul>
      <div className="btn_block bottom_button d-flex justify-content-center">
        <button
          className="btn btn_primary nextstep_cta"
          disabled={isResponseEmpty()}
          onClick={() => onSubmitHandler(currentChoice)}
        >
          {t("login.DOBSTEP.button")}
        </button>
      </div>
    </>
  );
}

export default MultipleChoice;
